import { render, staticRenderFns } from "./dam-sire-documents-container.vue?vue&type=template&id=40553cbf&scoped=true&lang=pug"
import script from "./dam-sire-documents-container.js?vue&type=script&lang=js&external"
export * from "./dam-sire-documents-container.js?vue&type=script&lang=js&external"
import style0 from "./dam-sire-documents-container.vue?vue&type=style&index=0&id=40553cbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40553cbf",
  null
  
)

export default component.exports